const menu = document.querySelector('.menu');
const navigation = document.querySelector('nav');
menu.addEventListener('click', () => {
  navigation.classList.toggle('open');
  menu.textContent = navigation.classList.contains('open') ? '×' : '☰';
});
document.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {
  navigation.classList.remove('open');
  menu.textContent = '☰';
}));

const interestForm = document.querySelector('#interest-form');
if (interestForm) {
  interestForm.addEventListener('submit', event => {
    event.preventDefault();
    const data = new FormData(interestForm);
    const message = `Hello Speak Up Center!%0A%0AI would like information about: ${encodeURIComponent(data.get('language'))}%0AName: ${encodeURIComponent(data.get('name'))}%0AWhatsApp: ${encodeURIComponent(data.get('phone'))}%0AEmail: ${encodeURIComponent(data.get('email') || 'Not provided')}%0APreferred time: ${encodeURIComponent(data.get('message') || 'Not provided')}`;
    window.location.assign(`https://wa.me/212665372285?text=${message}`);
  });
}
